module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    attrs: {
      "id": "graph-loads-per-day-scheduled",
      "height": "120"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-4492597e"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/ScheduledLoadsGraph.vue
// module id = 979
// module chunks = 0